<template lang="pug">
  .page-container
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container.lost-container
      v-form(ref="form")
        v-container
          v-layout
            v-flex(xs12)
              v-text-field(
                v-model="man"
                ref="man"
                :rules="nameRules"
                :label='$t("address.name")'
                required
                clearable
              )
          v-layout
            v-flex(xs12)
              v-text-field(
                v-model="phone"
                ref="phone"
                :rules="phoneRules"
                :label='$t("address.telephone")'
                required
                clearable
              )

          v-layout
            v-flex(xs12)
              v-select(
                v-model="provinceId"
                ref="provinceId"
                :rules="nameRules"
                :label='$t("address.province")'
                required
                :items='areaList'
                item-text="name"
                item-value="areaId"
              )
          v-layout
            v-flex(xs12)
              v-text-field(
                v-model="cityName"
                ref="cityName"
                :label='$t("address.city")'
                clearable
              )
          v-layout
            v-flex(xs12)
              v-text-field(
                v-model="address"
                ref="address"
                :rules="nameRules"
                :label="$t('address.street')"
                required
                clearable
              )
          v-layout
            v-flex(xs12)
              v-text-field(
                v-model="postcode"
                ref="postcode"
                :rules="nameRules"
                :label="$t('address.postcode')"
                required
                clearable
              )
          v-layout(row wrap)
            v-flex(xs12 sm6 md4)
              v-switch(
                v-model="defaultFlag"
                :label="$t('address.setDefault')"
              )

          v-layout(justify-start)
            v-flex(shrink mr-4)
              v-btn(color="primary" dark round large @click="submit" :loading='isLoading') {{ $t("address.save") }}

</template>

<script>
import { mapActions, mapState } from "vuex";
import account from "../../api/account.js";

export default {
  computed: {
    ...mapState(["areaList"]),
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "userinfo" },
          disabled: false,
          text: this.$t("nav.userInfo")
        },
        {
          to: { name: "address" },
          disabled: false,
          text: this.$t("nav.addressList")
        },
        {
          to: { name: "address-create" },
          disabled: true,
          text: this.$t("nav.createAddress")
        }
      ];
    },
    form() {
      return {
        man: this.man,
        phone: this.phone,
        provinceId: this.provinceId,
        postcode: this.postcode,
        address: this.address
      };
    },
    nameRules() {
      return [value => !!value || this.$t("address.required")];
    },
    phoneRules() {
      return [
        value => !!value || this.$t("address.required"),
        value => /^[679]\d{8}$/.test(value) || this.$t("address.phoneFormat")
      ];
    }
  },
  mounted() {
    this.loadAreaList();
  },

  data() {
    const address = this.$route.query.item;
    return {
      defaultFlag: address.cityName == 1 ? true : false,
      man: address.man || "",
      phone: address.phone || "",
      postcode: address.postcode || "",
      address: address.address || "",
      provinceId: address.provinceId || "",
      cityName: address.cityName || "",
      isLoading: false,
      addressId: this.$route.params.addressId
    };
  },

  methods: {
    ...mapActions(["loadAreaList"]),

    submit() {
      let formHasErrors = true;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.$refs[f].validate(true);
          formHasErrors = false;
        }
      });

      if (formHasErrors) {
        this.handleSubmit();
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await account.updateAddress({
          ...this.form,
          cityName: this.cityName,
          defaultFlag: this.defaultFlag ? 1 : 0,
          addressId: this.addressId
        });
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.$toasted.success(this.$t("address.saveSuccess"));
          setTimeout(() => {
            this.$router.back();
          }, 500);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./address.sass"></style>
